import React from 'react';
import { Truck, Calendar, Store } from 'lucide-react';
import { formatPhone } from '../utils/formatPhone';

interface DeliveryViewProps {
  cart: any[];
  customer: any;
  onBack: () => void;
  onDeliverySelected: (option: string, cost: number) => void;
}

function DeliveryView({ cart, customer, onBack, onDeliverySelected }: DeliveryViewProps) {
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  const totalPrice = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <div className="delivery-view">
      <div className="delivery-header">
        <button className="btn-secondary" onClick={onBack}>
          ← Atrás
        </button>
        <h1>Opciones de Entrega</h1>
        <div className="cart-summary-mini">
          <span>{totalItems} artículos</span>
          <span>${totalPrice.toFixed(2)}</span>
        </div>
      </div>

      <div className="delivery-content">
        <div className="customer-summary">
          <h3>Cliente seleccionado:</h3>
          <div className="customer-details">
            <p><strong>{customer.name}</strong></p>
            <p>{customer.email}</p>
            <p>{formatPhone(customer.phone)}</p>
          </div>
        </div>

        <div className="delivery-options">
          <h3>Selecciona el tipo de entrega:</h3>
          
          <div className="delivery-option" onClick={() => onDeliverySelected('En el lugar', 0.00)}>
            <div className="delivery-option-icon">
              <Store size={32} />
            </div>
            <div className="delivery-option-content">
              <h4>En el lugar</h4>
              <p>Entregar y pagar al momento</p>
              <span className="delivery-price">+$0.00</span>
            </div>
            <div className="delivery-option-select">→</div>
          </div>

          <div className="delivery-option" onClick={() => onDeliverySelected('Entrega', 0.00)}>
            <div className="delivery-option-icon">
              <Truck size={32} />
            </div>
            <div className="delivery-option-content">
              <h4>Entrega</h4>
              <p>Entrega a domicilio en 24-48 horas</p>
              <span className="delivery-price">+$0.00</span>
            </div>
            <div className="delivery-option-select">→</div>
          </div>

          <div className="delivery-option" onClick={() => onDeliverySelected('Programado', 0.00)}>
            <div className="delivery-option-icon">
              <Calendar size={32} />
            </div>
            <div className="delivery-option-content">
              <h4>Programado</h4>
              <p>Entrega en fecha y hora específica</p>
              <span className="delivery-price">+$0.00</span>
            </div>
            <div className="delivery-option-select">→</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryView; 